import {zNumberToString} from '@brunata-angular/util';
import {z} from 'zod';

export const variableAlarmSchema = z.object({
    deviationNotificRuleId: zNumberToString,
    allocationUnit: z.string(),
    deviationType: z.string(),
    deviationValue: z.number(),
    minimumDeviationPeriod: z.number().nullable(),
    activeStartTime: z.string().nullable(),
    activeEndTime: z.string().nullable(),
    throttle: z.number().nullable(),
    meterCriteriaMismatch: z
        .boolean()
        .optional()
        .transform(value => value ?? false),
    alarmName: z.string().nullable(),
    recipients: z.array(z.string().nullable()),
    unit: z.string().nullable(),
    meterIds: z.array(zNumberToString),
});

export type VariableAlarm = z.infer<typeof variableAlarmSchema>;

export type VariableAlarmWithTranslations = VariableAlarm & {
    usageTranslated: string;
    unitTranslated: string | null;
};

export const variableAlarmSubmitSchema = z.object({
    allocationUnit: z.string().nullable(),
    unit: z.number().nullable(),
    deviationType: z.string().nullable(),
    deviationValue: z.number().nullable(),
    minimumDeviationPeriod: z.number().nullable(),
    activeStartTime: z.string().nullable(),
    activeEndTime: z.string().nullable(),
    throttle: z.number().nullable(),
    alarmName: z.string().nullable(),
    recipients: z.array(z.string()),
    meterIds: z.array(z.string()),
});

export type VariableAlarmSubmit = z.infer<typeof variableAlarmSubmitSchema>;
export const variableAlarmEditSchema = variableAlarmSubmitSchema.omit({
    allocationUnit: true,
    unit: true,
});

export type VariableAlarmEdit = z.infer<typeof variableAlarmEditSchema>;
